TS.ns('WL');
WL.ApprovalRepeater = new Class({
    Extends: TS.domain.RepeaterEditDomain,

    hookDocument: function () {
        var me = this;
        owner = me.ParentDomain;

        me.watchProperty(me.Document().ApprovalStatusId, me.afterApprovalStatusIdChanged, me);

        var lkpApprovalStatus_Property = me.getDomainProperty('lkpApprovalStatus_Property');
        var lkpApprovalLevelId_Property = me.getDomainProperty('lkpApprovalLevelId_Property');

        if (lkpApprovalLevelId_Property != null) {
            lkpApprovalLevelId_Property.on('selectionChanging', me.onApprovalLevelChanging, me);
            lkpApprovalLevelId_Property.autoSelect = true;
        }

        if (lkpApprovalStatus_Property != null) {
            lkpApprovalStatus_Property.on('selectionChanging', me.onApprovalStatusChanging, me);
            lkpApprovalStatus_Property.autoSelect = true;
        }
    },

     
    afterApprovalStatusIdChanged: function (e) { 
        var me = this,
            owner = me.ParentDomain;
        if (me.Document().UpdatedBy() == null) {
            me.Document().UpdatedBy(owner.CurrentUserId());
            me.Document().UpdatedByName(owner.CurrentUserName());
            me.Document().UpdatedOn(new Date());
        }
        else if (me.Document().UpdatedBy() == owner.CurrentUserId() && me.Document().ApprovalStatusId() == 1) {
            me.Document().UpdatedBy(null);
            me.Document().UpdatedByName(null);
            me.Document().UpdatedOn(null);
        }
    },
    onApprovalLevelChanging: function (e) {
        e.preventDefault();
    },

    onApprovalStatusChanging: function (e) {
        var me = this,
            owner = me.ParentDomain;
        if (me.Document().UpdatedBy() != owner.CurrentUserId() && me.Document().ApprovalStatusId() != 1 && me.Document().UpdatedBy() != null) {
            e.preventDefault();
        }
    }
});      